import {
  SET_USERORGS,
  SET_USERORG,
  SET_USERORG_USERS,
  USERORG_ERROR,
} from "./actions";

const initialState = {
  items: [],
  item: null,
  users: [],
  error: null,
};

export default function userorganisaties(state = initialState, action = {}) {
  switch (action.type) {
    case SET_USERORGS:
      return { ...state, items: action.results, error: null };
    case SET_USERORG:
      return { ...state, item: action.result, error: null };
    case SET_USERORG_USERS:
      return { ...state, users: action.results };
    case USERORG_ERROR:
      return { ...state, error: action.error };
    default:
      return state;
  }
}
